import React from "react";

const Buttons =({OpenSettings,sendLinkSubmit})=>(
        <div className="background-blur-external">
            <div className="popup-contact-us text-center" style={{ height: 'auto',marginRight:'30px',borderRadius:'0',width:'200px' }}>
            <i className="fa fa-close" style={{float:'right',cursor:'pointer'}} onClick={()=>OpenSettings('close')}></i>

                <div className="row text-center" style={{marginTop:'20px'}}>
                    <div className="col-sm-12 col-xs-12">
                        <button className='btn btn-primary'onClick={()=>sendLinkSubmit('welcomeMail')} style={{marginTop:'15px',width:'100%'}}>Send Welcome Mail</button>
                    </div>
                 
                    <div className="col-sm-12 col-xs-12">
                        <button className='btn btn-primary' onClick={()=>sendLinkSubmit('profileComplete')} style={{marginTop:'15px',width:'100%'}}>Continue Journey</button>
                    </div>
                    <div className="col-sm-12 col-xs-12">
                        <button className='btn btn-primary' onClick={()=>sendLinkSubmit('uploadDocument')} style={{marginTop:'15px',width:'100%'}}>Send Document Link</button>
                    </div>
                </div>
            </div>

        </div>
    )

export default Buttons